document.addEventListener('DOMContentLoaded', () => {

    /* ==========================================================
       BOOKING STEPS
    ========================================================== */

    const steps = document.querySelectorAll('.exxtra-booking-step');
    const progress = document.querySelectorAll('.exxtra-booking-progress__item');

    /* ==========================================================
    BOOKING DATA
    ========================================================== */

    window.packAndMoveBooking = {

        property: {
            from: '',
            to: ''
        },

        package: {
            id: '',
            title: '',
            price: 0
        },

        delivery: {
            date: '',
            address: {}
        },

        move: {
            date: '',
            address: {}
        },

        containerCollectionDate: '',

        extendedRentalDays: 0,

        extendedRentalRate: 10,

        extendedRentalPrice: 0,


        elevator: {
            required: false,
            price: 0,
            variantId: '',
            title: '',
            displayPrice: '',
            rawPrice: 0
        }

    };

    const booking = window.packAndMoveBooking;

    function getProperty(name) {

        const field = document.querySelector(`[name="properties[${name}]"]`);

        return field ? field.value.trim() : '';

    }

    function setProperty(name, value) {

        const field = document.querySelector(`[name="properties[${name}]"]`);

        if (field) {
            field.value = value;
        }

    }

    function updateDeliveryFullName() {

        setProperty(
            'Delivery Full Name',
            `${getProperty('Delivery First Name')} ${getProperty('Delivery Last Name')}`.trim()
        );

    }

    function updatePropertyBooking() {

        booking.property.from =
            document.getElementById('moving-from')?.value || '';

        booking.property.to =
            document.getElementById('moving-to')?.value || '';

        booking.property.route =
            `${booking.property.from} → ${booking.property.to}`;

        updateSummary();

    }

    function showStep(step) {

        steps.forEach((stepElement) => {

            const isActive = Number(stepElement.dataset.step) === step;

            stepElement.hidden = !isActive;
            stepElement.classList.toggle('is-active', isActive);

        });

        progress.forEach((item, index) => {

            item.classList.toggle('is-active', index < step);

        });

        const summary = document.getElementById('bookingSummary');

        if (summary) {

            summary.hidden = (step === 0);

        }

        const howItWorks = document.querySelector('.exxtra-booking-how-it-works');

        if (howItWorks) {

            howItWorks.hidden = (step !== 0);

        }

        window.scrollTo({

            top: 0,
            behavior: 'smooth'

        });

    }

    

    
    /* ==========================================================
    BOOKING SUMMARY
    ========================================================== */

    function updateSummary() {

        updateDeliveryFullName();

        if (window.updatePackAndMoveSummary) {

            window.updatePackAndMoveSummary(booking);

        }

    }

    document.addEventListener('calendar:selected', (event) => {

        /*
        ==========================================================
        DELIVERY DATE
        ==========================================================
        */

        if (event.detail.type === 'delivery') {

            booking.delivery.date =
                event.detail.rawDate ||
                event.detail.date;

        }


        /*
        ==========================================================
        MOVE DATE
        ==========================================================
        */

        if (event.detail.type === 'collection') {

            booking.move.date =
                event.detail.rawDate ||
                event.detail.date;

        }


        /*
        ==========================================================
        CONTAINER COLLECTION DATE
        ==========================================================
        */

        if (event.detail.type === 'container_collection') {

            booking.containerCollectionDate =
                event.detail.rawDate ||
                event.detail.date;

            booking.extendedRentalDays =
                Number(event.detail.extendedRentalDays) || 0;

            booking.extendedRentalRate =
                Number(event.detail.extendedRentalRate) || 10;

            booking.extendedRentalPrice =
                Number(event.detail.extendedRentalPrice) || 0;

        }


        updateSummary();

    });

    /* ==========================================================
    PACKAGE SELECTION
    ========================================================== */

    const packageCards = document.querySelectorAll(
        '.pack-and-move-package-card'
    );

    packageCards.forEach(card => {

        card.addEventListener('click', () => {

            packageCards.forEach(c => {

                c.classList.remove('is-selected');

                const radio = c.querySelector(
                    '.pack-and-move-package-card__radio'
                );

                if (radio) radio.checked = false;

            });

            card.classList.add('is-selected');

            const radio = card.querySelector(
                '.pack-and-move-package-card__radio'
            );

            if (radio) radio.checked = true;

            booking.package.id = card.dataset.variantId || '';
            booking.package.title = card.dataset.packageTitle || '';
            booking.package.route = card.dataset.route || '';
            booking.package.price = Number(card.dataset.packagePrice || 0);

            console.log('Package Selected', booking.package);

            updateSummary();

        });

    });

    function updateMoveToOptions() {

    const fromSelect = document.getElementById('moving-from');
    const toSelect = document.getElementById('moving-to');

    if (!fromSelect || !toSelect) return;

    const selectedFrom = fromSelect.value;

    /* ----------------------------------------------------------
       No origin selected
       ---------------------------------------------------------- */

    if (!selectedFrom) {

        [...toSelect.options].forEach(option => {

            option.disabled = false;

        });

        toSelect.value = '';

        return;

    }

    /* ----------------------------------------------------------
       Get available routes from package cards
       ---------------------------------------------------------- */

    const validDestinations = new Set();

    document
        .querySelectorAll('.pack-and-move-package-card')
        .forEach(card => {

            const route = card.dataset.route;

            if (!route) return;

            const parts = route.split(' to ');

            if (parts.length !== 2) return;

            const fromPart = parts[0].trim();
            const toPart = parts[1].trim();

            const fromOptions = fromPart
                .split('/')
                .map(item => item.trim());

            if (fromOptions.includes(selectedFrom)) {

                validDestinations.add(toPart);

            }

        });

    /* ----------------------------------------------------------
       Enable / disable destination options
       ---------------------------------------------------------- */

    [...toSelect.options].forEach(option => {

        if (!option.value) {

            option.disabled = false;

            return;

        }

        option.disabled =
            !validDestinations.has(option.value);

    });

    /* ----------------------------------------------------------
       Clear destination if current selection is no longer valid
       ---------------------------------------------------------- */

    if (
        toSelect.value &&
        !validDestinations.has(toSelect.value)
    ) {

        toSelect.value = '';

    }

}

       /* ==========================================================
       DELIVERY AND COLLECTION DATE
       ========================================================== */

        document
            .querySelectorAll('#moving-from, #moving-to')
            .forEach(select => {

                select.addEventListener('change', () => {

                    /* Update destination options when origin changes */

                    if (select.id === 'moving-from') {

                        updateMoveToOptions();

                    }

                    updatePropertyBooking();
                    updateSummary();

                });

        });

        updateMoveToOptions();

        const collectionDate = document.querySelector(
        '[data-summary="collection"]'
    );

    if (collectionDate) {

        collectionDate.textContent =
            booking.delivery.date || '—';

    }

        const movingDate = document.querySelector(
        '[data-summary="move-date"]'
    );

    if (movingDate) {

        movingDate.textContent =
            booking.move.date || '—';

    }

    /* ==========================================================
    ADDRESS FORM
    ========================================================== */

    document.querySelectorAll('[data-booking-form]').forEach(form => {

        const type = form.dataset.bookingType;

        form.querySelectorAll('[data-booking-field]').forEach(field => {

            field.addEventListener('input', updateAddress);
            field.addEventListener('change', updateAddress);

        });

        function updateAddress() {

            const address = {

                fullName: form.querySelector('[data-booking-field="fullName"]')?.value || '',
                phone: form.querySelector('[data-booking-field="phone"]')?.value || '',

                line1: form.querySelector('[data-booking-field="line1"]')?.value || '',
                line2: form.querySelector('[data-booking-field="line2"]')?.value || '',

                postcode: form.querySelector('[data-booking-field="postcode"]')?.value || '',
                unit: form.querySelector('[data-booking-field="unit"]')?.value || '',

                elevator: form.querySelector('[data-booking-field="elevator"]')?.value || ''

            };

            console.log({
                type,
                delivery: booking.delivery.address,
                move: booking.move.address
            });

            if (type === 'delivery') {

                booking.delivery.address = address;

            }

            if (type === 'move') {

                booking.move.address = address;

            }

            /* ----------------------------------------------------------
            Elevator Required
            ---------------------------------------------------------- */

            if (

                booking.delivery.address.elevator === 'No' ||
                booking.move.address.elevator === 'No'

            ) {

                booking.elevator = {

                    required: true,

                    variantId: 42437239111755

                };

            } else {

                booking.elevator = {

                    required: false,

                    variantId: ""

                };

            }

            updateSummary();

        }

        updateAddress();

    });

    /* ==========================================================
       PACKAGE CAROUSEL
    ========================================================== */

    const carousel = document.querySelector('.exxtra-booking-package-carousel');

    if (carousel) {

    const slides = [...carousel.querySelectorAll('.exxtra-booking-package-slide')];

    const prevButton = carousel.querySelector('.exxtra-booking-package-carousel__arrow--prev');
    const nextButton = carousel.querySelector('.exxtra-booking-package-carousel__arrow--next');

    const currentCounter = carousel.querySelector('.package-current');
    const totalCounter = carousel.querySelector('.package-total');

    let current = 0;

    totalCounter.textContent = slides.length;

    function updateCarousel() {

        slides.forEach((slide, index) => {

            slide.classList.remove(
                'is-prev',
                'is-active',
                'is-next',
                'is-hidden'
            );

            if (index === current) {

                slide.classList.add('is-active');

            } else if (index === current - 1) {

                slide.classList.add('is-prev');

            } else if (index === current + 1) {

                slide.classList.add('is-next');

            } else {

                slide.classList.add('is-hidden');

            }

            const radio = slide.querySelector('.exxtra-booking-package-card__radio');

            if (radio) {

                radio.checked = index === current;

            }

        });

        currentCounter.textContent = current + 1;

        prevButton.disabled = current === 0;
        nextButton.disabled = current === slides.length - 1;

        /* ----------------------------------------------------------
        Update selected package
        ---------------------------------------------------------- */

        
    }

    prevButton.addEventListener('click', () => {

        if (current > 0) {

            current--;
            updateCarousel();
            updateSummary(); 

        }

    });

    nextButton.addEventListener('click', () => {

        if (current < slides.length - 1) {

            current++;
            updateCarousel();
            updateSummary();

        }

    });

    slides.forEach((slide, index) => {

        slide.addEventListener('click', () => {

            current = index;

            updateCarousel();

            booking.package.id =
                slide.dataset.variantId || '';

            booking.package.title =
                slide.dataset.variantTitle ||
                slide.dataset.packageTitle ||
                '';

            booking.package.route =
                slide.dataset.route || '';

            booking.package.price =
                Number(
                    slide.dataset.variantPrice ||
                    slide.dataset.packagePrice ||
                    0
                );

            updateSummary();

            console.log(
                'Package Selected',
                booking.package
            );

        });

    });

    /* ==========================================================
       TOUCH SUPPORT
    ========================================================== */

    let touchStartX = 0;
    let touchEndX = 0;

    carousel.addEventListener('touchstart', (e) => {

        touchStartX = e.changedTouches[0].clientX;

    });

    carousel.addEventListener('touchend', (e) => {

        touchEndX = e.changedTouches[0].clientX;

        const distance = touchEndX - touchStartX;

        if (Math.abs(distance) < 50) return;

        if (distance < 0 && current < slides.length - 1) {

            current++;
            updateCarousel();
            updateSummary();

        }

        if (distance > 0 && current > 0) {

            current--;
            updateCarousel();
           updateSummary(); 

        }

    });
}

   
});